import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import { MSEnum } from '@/commons/enumeration';

class AgreementLicenseAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = "TaskGo";
	controllerName = 'PersonalAgreements';

	/**
	 * Check thỏa thuận đã được xác nhận hay chưa
	 * VDGiang 14/7/2023
	 */
	checkAgreementApp(param) {
		let request = {
			url: `${this.getAPIUrl()}/users/agreements`,
			data: param
		};

		return httpClient.postAsync(request);
	}
	/**
	 * Kiểm tra đã xác nhận thỏa thuận chưa (v2)
	 * @param {*} param 
	 * @returns 
	 */
	checkAgreementAppV2(param) {
		let request = {
			url: `${this.getAPIUrl()}/users/agreementsv2`,
			data: param
		};

		return httpClient.postAsync(request);
	}

	/**
	 * Xấc nhận thỏa thuận sử dụng
	 * VDGiang 14/7/2023
	 * @param param
	 * @returns
	 */
	saveAgreement(param) {
		let request = {
			url: `${this.getAPIUrl()}/saveAgreement`,
			data: param
		};

		return httpClient.postAsync(request);
	}
	/**
	 * Lưu xác nhận thỏa thuận v2
	 * @param {*} param 
	 * @returns 
	 */
	saveAgreementV2(param) {
		let request = {
			url: `${this.getAPIUrl()}/saveAgreementv2`,
			data: param
		};

		return httpClient.postAsync(request);
	}

	getAgreementsHistory(param) {
		let request = {
			url: `${this.getAPIUrl()}/users/agreements-history`,
			data: param
		};

		return httpClient.postAsync(request);
	}

	/**
 * Cập nhật lại số thứ tự chức vụ
 * @param param
 * @returns
 */
	getAgreementLicense(orgID) {
		let request = {
			url: `${this.getAPIUrl()}/AgreementLicense?orgID=${orgID}`,
		};

		return httpClient.getAsync(request);
	}
}

export default new AgreementLicenseAPI();
